import { render, staticRenderFns } from "./idNumber.vue?vue&type=template&id=c485c55c&scoped=true&"
import script from "./idNumber.vue?vue&type=script&lang=js&"
export * from "./idNumber.vue?vue&type=script&lang=js&"
import style0 from "./idNumber.vue?vue&type=style&index=0&id=c485c55c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c485c55c",
  null
  
)

export default component.exports